import { pushRoute } from '../../../lib/router.js';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Col, Grid, Row } from 'react-bootstrap';
import { Form } from 'react-final-form';
import { getOrgTermsContent } from '../../../content/utils.js';
import { getOrgSlug, mapFinalFormErrors } from '../../../lib/utils.js';
import {
  deletePortfolio,
  finishUpdatePortfolioDraft,
  selectPortfolioDraft,
  selectPortfolioDraftId,
  updatePortfolioDraft,
} from '../../../modules/portfolio.js';
import {
  navigateToStepMilestones,
  onCreateUpdateCancel,
  onReset,
} from './utils/index.js';
import StepLinkedFilesForm from '../../../components/portfolio/EditPortfolioForms/StepLinkedFilesForm.jsx';
import PortfolioHeader from '../../../components/headers/PageHeaders/Portfolio/PortfolioHeader.jsx';
import MultistepCombinedHeader from '../../../components/headers/FormHeaders/MultistepCombinedHeader.jsx';

const mapErrors = mapFinalFormErrors('Failed to save change strategy');

const randomId = () => Math.random().toString(36).slice(2, 7);

const mapStateToProps = (state, ownProps) => ({
  editing: !!ownProps.portfolioId,
  portfolioId: ownProps.portfolioId,
  draftId: selectPortfolioDraftId(state),
  portfolioDraft: selectPortfolioDraft(selectPortfolioDraftId(state))(state),
});

const mapDispatchToProps = {
  updatePortfolioDraft,
  finishUpdatePortfolioDraft,
  deletePortfolio,
};

function StepLinkedFilesFormContainer({
  editing,
  draftId,
  portfolioId,
  portfolioDraft,
  deletePortfolio,
  finishUpdatePortfolioDraft,
}) {
  const [entities, setEntities] = useState([]);
  const [loading, setLoading] = useState(false);

  const goBack = () =>
    navigateToStepMilestones(editing, portfolioId, getOrgSlug());
  const onCancel = () =>
    onCreateUpdateCancel(draftId, deletePortfolio, getOrgSlug());

  const onCreateLinkedFile = () => {
    setEntities([
      ...entities,
      {
        tempId: randomId(),
        name: '',
        url: '',
      },
    ]);
  };
  const onFieldChange = (index, key, val) => {
    setEntities((prevState) => {
      const newState = [...prevState];
      newState[index] = { ...newState[index], [key]: val };
      return newState;
    });
  };

  const onDeleteLinkedFile = (key, val) => {
    if (!window.confirm('Are you sure you want to delete this linked file?'))
      return;

    setEntities((prevState) => prevState.filter((item) => item[key] !== val));
  };

  const onSubmit = (values) => {
    const draft = {
      linked_files: entities,
    };

    return finishUpdatePortfolioDraft(draftId, draft, true)
      .then(({ result }) =>
        pushRoute('portfolio/show/info', { portfolioId: result })
      )
      .catch(mapErrors);
  };

  const validate = () => {
    const errors = {};

    if (entities.length) {
      entities.forEach((item, index) => {
        if (!item.name) errors[`name${index}`] = "Can't be blank";
        if (item.name && !item.url) errors[`url${index}`] = "Can't be blank";
      });
    }

    return errors;
  };

  useEffect(() => {
    if (portfolioDraft && !entities.length) {
      setEntities(portfolioDraft.linked_files);
    }
  }, [portfolioDraft]);

  useEffect(() => {
    !portfolioDraft && onReset(editing, portfolioId, slug);
  }, []);

  return (
    <React.Fragment>
      <MultistepCombinedHeader
        editing={editing}
        subject={getOrgTermsContent('portfolio')}
        typeStep="Linked Files"
      >
        <PortfolioHeader portfolio={portfolioDraft} editing={editing} />
      </MultistepCombinedHeader>

      <Grid>
        <Row>
          <Col sm={12}>
            <div className="component-xl component-bg-white component-xl-padding-vertical component-no-horizontal-padding">
              <Row>
                <Col sm={10} smOffset={1}>
                  <Form
                    validate={validate}
                    entities={entities}
                    onCreateLinkedFile={onCreateLinkedFile}
                    onFieldChange={onFieldChange}
                    onDeleteLinkedFile={onDeleteLinkedFile}
                    loading={loading}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    onBack={goBack}
                    component={StepLinkedFilesForm}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Grid>
    </React.Fragment>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StepLinkedFilesFormContainer);
